import { useQuery } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

import { chatShareQueryKey } from "./chat-share.constants";

export const useGetChatShare = (chatUuid: string, enabled: boolean) => {
  return useQuery({
    queryKey: chatShareQueryKey(chatUuid),
    queryFn: () => chatApi.getChatShare(chatUuid),
    enabled,
  });
};
